var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calculate-your-taxes"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col"},[_c('tax-lookup',{attrs:{"lookup-type":"reevaluation","disclaimer":_vm.disclaimer,"note":_vm.note}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }